import baseButton, { getCommonStyleSheet } from '@bubble-ui/temp-base-button';
var primaryColors = () => ({
  variant: 'primary'
});
export default baseButton('ButtonPrimary', getCommonStyleSheet(primaryColors));
//# sourceMappingURL=index.js.map